export const BENEFICIARY_ERRORS = {
  relationship: {
    max: 'Relationship must be no more than 25 characters',
    invalid: 'Relationship type is invalid',
    required: 'Relationship is required',
  },
  entityType: {
    invalid: 'Entity type is invalid',
    required: 'Entity type is required',
  },
  entityName: {
    required: 'Name is required',
    max: 'The entity name must be no more than 30 characters',
  },
  name: {
    withMiddleTooLong:
      'Your first, middle and last name together cannot be more than 26 characters.',
    withoutMiddleTooLong:
      'Your first and last name together cannot be more than 27 characters.',
    firstRequired: 'First name is required',
    lastRequired: 'Last name is required',
  },
  dateOfBirth: {
    invalid: 'Please enter a valid date of birth',
  },
  identification: {
    invalidSSN: 'Invalid SSN',
    invalidTIN: 'Invalid TIN',
  },
  address: {
    max: 'Address must be no more than 30 characters',
  },
  city: {
    max: 'City must be no more than 21 characters',
  },
  state: {
    invalid: 'Invalid state',
  },
  zipCode: {
    invalid: 'Invalid zip code',
    min5: 'Zip code must be at least 5 characters',
    min9: 'Zip code must be at least 9 characters',
    max: 'Zip code must be no more than 9 characters',
  },
  phone: {
    invalid: 'Phone number is invalid',
  },
  email: {
    invalid: 'Email address is invalid',
    max: 'Email must be no more than 50 characters',
  },
} as const;

export const BENEFICIARIES_ERRORS = Object.assign({}, BENEFICIARY_ERRORS, {
  relationship: {
    invalid: 'Individual beneficiaries must have a valid relationship type',
    required: 'Individual beneficiaries must have a relationship type',
  },
  entityType: {
    invalid: 'Entity beneficiaries must have a valid entity type',
    required: 'Entity beneficiaries must have an entity type',
  },
  entityName: {
    required: 'Entity beneficiaries must have a name',
    max: 'Entity beneficiaries must have a name which is no more than 28 characters long',
  },
  name: {
    withMiddleTooLong:
      'Your first, middle and last name together cannot be more than 26 characters.',
    withoutMiddleTooLong:
      'Your first and last name together cannot be more than 27 characters.',
    firstRequired: 'Individual beneficiaries must have a first name',
    lastRequired: 'Individual beneficiaries must have a last name',
  },
  dateOfBirth: {
    invalid: 'Individual beneficiaries must have a valid date of birth',
  },
  identification: {
    invalidSSN: 'Individual beneficiaries must have a valid SSN',
    invalidTIN: 'Entity beneficiaries must have a valid TIN',
  },
  address: {
    max: 'Beneficiaries must have a valid address line 1',
  },
  city: {
    max: 'Beneficiaries must have a valid city',
  },
  state: {
    invalid: 'Beneficiaries must have a valid state',
  },
  zipCode: {
    invalid: 'Beneficiaries must have a valid zip code',
    min5: 'Beneficiaries must have a valid zip code',
    min9: 'Beneficiaries must have a valid zip code',
    max: 'Beneficiaries must have a valid zip code',
  },
  phone: {
    invalid: 'Beneficiaries must have a valid phone number',
  },
  email: {
    invalid: 'Beneficiaries must have a valid email address',
  },
  percentage: {
    positive: 'Beneficiaries must have an allocation greater than 0%',
    required: 'Beneficiaries must have an allocation greater than 0%',
  },
});
